import styled from 'styled-components';

export const SanitizingWrapper = styled.div`
  & * {
    outline: 0 !important;
  }
  & input {
    border: 0;
  }
`;
